(function() {
  let deferredPrompt = null;

  window.addEventListener('beforeinstallprompt', function(e) {
    e.preventDefault();
    deferredPrompt = e;

    // Mostrar el botón cuando el evento esté listo
    const btn = document.getElementById('pwa-install-btn');
    if (btn) btn.style.display = 'block';
  });

  window.addEventListener('appinstalled', function() {
    // Ocultar el botón si ya se instaló
    const btn = document.getElementById('pwa-install-btn');
    if (btn) btn.style.display = 'none';
    deferredPrompt = null;
  });

  // Exponer la función globalmente para que el botón la llame
  window.installPWA = function() {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then(function(result) {
      deferredPrompt = null;
    });
  };
})();
